import React from "react";
import { useNavigate } from "react-router-dom";

const templates = [
  {
    id: "releasenotesemail",
    name: "What's New in Listernaut",
    image:
      "https://storage.googleapis.com/listalotimages/emailtemplates/release.png",
  },
  {
    id: "marketingemail",
    name: "Marketing Email",
    image:
      "https://storage.googleapis.com/listalotimages/emailtemplates/market.png",
  },
  {
    id: "announcementemail",
    name: "Announcement Email",
    image: "https://storage.googleapis.com/listalotimages/emailtemplates/announcement.png",
  },
];

const ReleaseNotesEmailGallery = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f3f5f9] py-10 px-6 flex flex-col items-center">
      <div className="max-w-6xl w-full">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-extrabold text-[#333999]">
            📧 Email Templates
          </h1>

          <button
            onClick={() => navigate("/marketingadmin")}
            className="bg-[#333999] text-white px-4 py-2 rounded-lg font-semibold shadow-md hover:shadow-lg hover:opacity-95 transition-all"
          >
            Marketing Admin
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {templates.map((t) => (
            <div
              key={t.id}
              onClick={() => navigate(`/${t.id}`)}
              className="cursor-pointer bg-white rounded-xl shadow-md border-2 border-[#333999] overflow-hidden hover:scale-[1.02] hover:shadow-lg transition-transform duration-200"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={t.image}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-center py-3 bg-white">
                <h3 className="text-lg font-semibold text-[#333999]">
                  {t.name}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-gray-500 mt-10">
          Click a template to open its editor and customize it.
        </p>
      </div>
    </div>
  );
};

export default ReleaseNotesEmailGallery;